import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TripAttributes } from '~app/models/trip';
import { OkayModalComponent } from '~app/components/shared/okay-modal/okay-modal.component';
import { NgIf, NgClass } from '@angular/common';
import { guestCrewHaveRequiredPoc } from '~app/utilities';

@Component({
  selector: 'ciao-okay-modal-section-v3',
  imports: [OkayModalComponent, NgIf, NgClass],
  templateUrl: './okay-modal-section.component.html',
  styleUrl: './okay-modal-section.component.less',
})
export class OkayModalSectionComponent {
  @Input() trip: TripAttributes;
  @Output('checkInEvent') checkInEvent = new EventEmitter<string>();

  canOkay(...args) {
    return true;
  }
  emitCheckpointEvent() {
    this.checkInEvent.emit('logNextCheckpoint');
  }

  get canCheckout() {
    return (
      this.trip.id &&
      this.trip.startDate &&
      this.trip.endDate &&
      this.trip.usergroup &&
      this.trip.locations.length > 0 &&
      this.trip.crewMembers.length > 0 &&
      guestCrewHaveRequiredPoc(this.trip.crewMembers)
    );
  }
}
